module.exports = __webpack_public_path__ + "img/time-bg.86aab03a.png";